// Entry for the standalone /signup page (signup.html). The self-serve wizard is
// public and self-contained (own reducer, no router/store/Kendo), so it gets its
// own tiny bundle instead of booting the whole SPA: dnc.com opens this URL in a
// <dialog><iframe> on "Start Here", and that first paint is the top of the PLG funnel.
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { SignupWizard } from "./components/SignupWizard/SignupWizard";
import "./signup.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <SignupWizard fullPage />
  </StrictMode>,
);
